import React, { useState, Fragment } from 'react';
import { Grid, Select, TextField, withStyles, MenuItem, InputAdornment, InputLabel, FormControl } from '@material-ui/core';
import PropTypes from 'prop-types';
import { Toastr } from 'data/common';
import SaveButton from './SaveButton';
import Translator from '../../../../../../../../../../../translator';

function Field({ field, classes, product_identifier, code, inelioSetParamAction, fheCenter_mac }) {
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [value, setValue] = useState(field.value);
    const [touched, setTouched] = useState(false);

    const handleChange = e => {
        error && setError(false);
        const newValue = e.target.value;
        setValue(newValue);
        if (String(newValue) === String(field.value)) {
            setTouched(false);
        } else {
            setTouched(true);
        }
    };

    const handleSave = async () => {
        const number = Number(value);
        if (number >= field.range[0] && number <= field.range[1]) {
            try {
                setLoading(true);
                const response = await inelioSetParamAction({ product_identifier, code, param: field.name, value: number, fheCenter_mac });
                Toastr.success(Translator.translate('general.products.SDM19INL.socket.settings.success'));
                setValue(response.value);
                setTouched(false);
            } catch (e) {
                Toastr.error(Translator.translate('general.products.SDM19INL.socket.settings.error'), e);
            } finally {
                setLoading(false);
            }
        } else {
            setError(true);
            setValue(field.value);
        }
    };

    const handleKeyPress = e => {
        if (e.key === 'Enter') {
            return handleSave();
        }
    };

    return (
        <Grid container item xs={12} md={6} lg={4} className={classes.container}>
            <Grid item xs={12}>
                <div className={classes.label}>{field.label}</div>
            </Grid>

            <Grid item xs={12} container alignItems="center">
                <Grid item xs={10}>
                    {field.unit === 'enum' ? (
                        <FormControl>
                            <InputLabel id={field.name}>{field.name}</InputLabel>
                            <Select
                                id={field.name}
                                label={field.name}
                                name={field.name}
                                value={value}
                                onChange={handleChange}
                                style={{ width: 175 }}
                                onKeyPress={handleKeyPress}
                            >
                                {field.options.map(option => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    ) : (
                        <Fragment>
                            <TextField
                                autoComplete="off"
                                style={{ width: 100 }}
                                name={field.name}
                                label={field.name}
                                value={value}
                                onChange={handleChange}
                                onKeyPress={handleKeyPress}
                                type="number"
                                inputProps={{
                                    min: field.range[0],
                                    max: field.range[1],
                                }}
                                InputProps={{
                                    endAdornment: <InputAdornment position="end">{field.unit}</InputAdornment>,
                                }}
                                error={error}
                                helperText={error && JSON.stringify(field.range)}
                            />
                        </Fragment>
                    )}
                </Grid>
                <Grid container item xs={2}>
                    <SaveButton loading={loading} disabled={!touched} onClick={handleSave} />
                </Grid>
            </Grid>
        </Grid>
    );
}

const styles = theme => ({
    container: {
        marginBottom: 20,
    },
    label: {
        color: theme.palette.primary.main,
        fontWeight: 'bold',
        marginBottom: 2,
    },
    saveIcon: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
    },
});

Field.propTypes = {
    classes: PropTypes.object.isRequired,
    field: PropTypes.object.isRequired,
    inelioSetParamAction: PropTypes.func.isRequired,
    product_identifier: PropTypes.string.isRequired,
    code: PropTypes.string.isRequired,
    fheCenter_mac: PropTypes.string.isRequired,
};
Field.defaultProps = {};

export default withStyles(styles, { withTheme: true })(Field);



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Products/components/Product/Fhe/SDM19INL/components/Field.js